<template>
    <footer class="bg-grey-lighten-1">
      <div class="px-4 py-2 text-center">
        {{ new Date().getFullYear() }} — <strong>eduBB</strong>
      </div>
      <button v-if="isButtonUpdated">New Release Available!</button>
      <button v-else>Current Release</button>
    </footer>
  </template>

  <script>
  export default {
    name: "Footer",
    data: () => ({
    }),
    computed: {
      isButtonUpdated() {
        return this.$store.state.isButtonUpdated;
      },
    },
  }
</script>